export default function VoiceLogo({ className = "" }) {
  return (
    <svg
      viewBox="0 0 90 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ width: '90px', height: '40px' }}
    >
      {/* Simple elegant face profile silhouette - facing right */}
      {/* Forehead, nose, lips, chin - single continuous line */}
      <path
        d="M12 4
           C16 2, 22 2, 26 5
           C27 7, 27 9, 27 11
           C30 14, 34 19, 35 22
           C36 24, 35 26, 33 26
           C33 27, 33 28, 34 30
           C33 33, 29 35, 24 36
           C19 37, 14 36, 10 34"
        stroke="#c0c0c0"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      
      {/* Sound waves - three arcs getting bigger */}
      <path d="M42 27 Q48 24, 48 28 Q48 32, 42 30" stroke="#7c3aed" strokeWidth="2.5" strokeLinecap="round" fill="none" />
      <path d="M54 22 Q64 17, 64 28 Q64 39, 54 34" stroke="#7c3aed" strokeWidth="2.5" strokeLinecap="round" fill="none" opacity="0.5" />
      <path d="M70 15 Q86 8, 86 28 Q86 48, 70 41" stroke="#7c3aed" strokeWidth="2.5" strokeLinecap="round" fill="none" opacity="0.2" />
    </svg>
  );
}
